import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { GeolocationService } from "../services/geolocationservice";
import { sweetalert } from "../services/sweetalert";
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from "src/environments/environment";

@Component({
  selector: "app-mfi-screen",
  templateUrl: "./mfi-screen.component.html",
  styleUrls: ["./mfi-screen.component.css"],
})
export class MfiScreenComponent implements OnInit {
  totalincomerange: any;
  incomebandrange: any = "";
  submitted = false;
  checkboxVal: any = "Married";
  Father: string = "N";
  Mothers: string = "N";
  UnmarriedChildren: string = "N";
  Spouse: string = "N";
  accepted: boolean;
  totalincomevalue: any;
  checked: boolean;
  loader: boolean;
  custid: any;
  mobile: any;
  responseData: any;
  showFamilyIncome: boolean = false;
  numericNumberReg = "^-?[0-9]\\d*(\\.\\d{1,2})?$";
  system: any;
  previousincome: number;
  mfiIncomedata: any;
  reasonList: any;
  reasonflag: boolean;
  selectedReason: any = '';
  increaseReasonList: any;
  decreaseReasonList: any;
  mfiSalaryVal: any
  encData: any;
  totalSalValidators: any;
  constructor(
    private sweetalert: sweetalert,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private httpClient: HttpClient,
    private service: GeolocationService
  ) { }

  ngOnInit(): void {
    this.loader = true;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.encData = params["data"] != null ? params["data"] : null;
      this.custid = params["custid"] != null ? params["custid"] : null;
      if (this.custid == null) {
        this.custid = params["custID"] != null ? params["custID"] : null;

      }
      this.mobile = params["mobile"] != null ? params["mobile"] : null;
      this.system = params["system"] != null ? params["system"] : null;
      // console.log('system' +this.system);
      let reqObj: any;
      if (this.encData != null && this.encData != '') {
        reqObj = {
          encData: `${this.encData}`,

        }
        this.getMfiIncome(reqObj);
      } else if (this.custid != null && this.custid != '' && this.mobile != null && this.mobile != '') {
        reqObj = {
          custid: `${this.custid}`,
          mobile: `${this.mobile}`,
          system: `${this.system}`
        }
        this.getMfiIncome(reqObj);
      }
      else {
        this.sweetalert.errorsweertalert("No Data Found..!!");
      }

      (error) => {
        console.error("Unable to Process");
      };

    });
    this.loader = false;
    this.totalSalValidators = [
      Validators.required,
      Validators.min(1000),
      Validators.max(9999999)
    ];
  }

  basicdetailsform = this.fb.group({
    incomebandrange: [
      "",
      [
        Validators.required,
        Validators.min(1000),
        Validators.max(999999),
        Validators.pattern(this.numericNumberReg),
      ],
    ],
    totalincomebandrange: [
      "",
      [
        Validators.required,
        Validators.min(1000),
        Validators.max(9999999),
        Validators.pattern(this.numericNumberReg),
      ],
    ],
    reason: ["undefined", [Validators.required]]
  });
  allowOnlyNumbers(event: KeyboardEvent, modelValue: any, type: any) {
    var typeValue = type === 1 ? 'totalincomebandrange' : 'incomebandrange';
    if (/[^0-9]*/g.test(event.key)) {
      this.basicdetailsform.controls[typeValue].setValue(modelValue.replace(/[^0-9]*/g, '').replace(/^0+/, ''));
    }
  }
  checkBorrowerIncome(event: any, type: string, name: string) {
    const data = event.target.value;
    this.basicdetailsform.get('reason')?.setValue("undefined");
    this.selectedReason = null;
    document.getElementById('disabledReason')?.setAttribute('disabled', 'true');
    if (type == 'borrowerIncome' && data > Number(this.mfiSalaryVal)) {
      this.showFamilyIncome = false;
      this.totalincomerange = null;
      this.basicdetailsform.get('totalincomebandrange').clearValidators();
      this.basicdetailsform.get('totalincomebandrange').updateValueAndValidity();
    } else {
      this.showFamilyIncome = true;
      this.basicdetailsform.controls['totalincomebandrange'].setValidators([Validators.required]);
      this.basicdetailsform.controls['totalincomebandrange'].setValidators(this.totalSalValidators);
    }
    if (parseInt(data) == parseInt(this.totalincomerange) && parseInt(data) == this.previousincome || parseInt(data) == this.previousincome && this.totalincomerange == null
      || parseInt(data) == this.previousincome && this.basicdetailsform.get('totalincomebandrange').value == '' || parseInt(data) < this.previousincome && this.basicdetailsform.get('totalincomebandrange').value == '' || parseInt(data) < this.previousincome && this.basicdetailsform.get('totalincomebandrange').value == this.previousincome
      || (this.previousincome == parseInt(this.totalincomerange) && (parseInt(data) > parseInt(this.totalincomerange) || data == "") && type == 'borrowerIncome')) {
      this.reasonflag = false;
    } else {
      // if (this.totalincomerange != null || parseInt(data) == this.previousincome && this.previousincome > parseInt(this.totalincomerange ||  parseInt(data) < this.previousincome && this.basicdetailsform.get('totalincomebandrange').value == '' )) {
      if (this.totalincomerange != null || parseInt(data) == this.previousincome && this.previousincome > parseInt(this.totalincomerange || parseInt(data) < this.previousincome && this.totalincomerange == null)) {
        if (parseInt(this.totalincomerange) > this.previousincome) {
          this.reasonList = this.increaseReasonList;
        } else {
          this.reasonList = this.decreaseReasonList;
        }
        this.reasonflag = true;
      }
      else {
        if (parseInt(data) != this.previousincome) {
          if (parseInt(data) > this.previousincome) {
            this.reasonList = this.increaseReasonList;
          } else {
            this.reasonList = this.decreaseReasonList;

          }

          this.reasonflag = true;
        }
      }
    }
  }

  getMfiIncome(reqObj: any) {
    this.httpClient.post(environment.baseUrl + "/tvsm/getMfiIncome", reqObj).toPromise()
      .then((data: any) => {
        console.log({ data });
        this.mfiIncomedata = data.response;
        this.previousincome = this.mfiIncomedata.borrowerIncomeasperRecord;
        this.mfiSalaryVal = this.mfiIncomedata.mfiSalaryVal;
        this.reasonList = JSON.parse(this.mfiIncomedata.reasondropdownlist);
        this.increaseReasonList = this.reasonList.filter(e => e.type == "Increase" || e.type == "Both");
        this.decreaseReasonList = this.reasonList.filter(e => e.type == "Decrease" || e.type == "Both");
        this.custid = data.custid;
        this.mobile = data.mobno;
        this.system = data.system;

      });

  }

  save(event: any) {
    console.log("selected reason" + this.selectedReason);
    if ((this.selectedReason == "" || this.selectedReason == null) && this.reasonflag == true) {
      console.log("selected reason");
      this.sweetalert.errorsweertalert("Please select reason for change in income!");
    } else {
      console.log("data: this.incomebandrange" + this.incomebandrange);
      this.loader = true;
      this.submitted = true;
      if (
        this.incomebandrange !== "" &&
        this.totalincomerange !== "" &&
        Number(this.incomebandrange) == Number(this.totalincomerange) &&
        this.Father == "N" &&
        this.Mothers == "N" &&
        this.Spouse == "N" &&
        this.UnmarriedChildren == "N"
      ) {
        //console.log("data: 8");
        if (Number(this.incomebandrange) == 0) {
          this.submitted = false;
          this.sweetalert.errorsweertalert("Enter valid amount");
        }
        else {
          this.saveMfiData();
        }

      } else if (
        this.incomebandrange !== "" &&
        Number(this.incomebandrange) <= Number(this.mfiSalaryVal)
      ) {
        //console.log("data: 2");
        if (!this.basicdetailsform.valid) {
          //console.log("data: 4");
          this.loader = false;
          this.submitted = false;
          this.sweetalert.errorsweertalert("Please fill mandatory fields");
          if (this.totalincomerange > 9999999 || this.totalincomerange < 1000 || this.incomebandrange > 999999 || this.incomebandrange < 1000) {
            this.loader = false;
            this.submitted = false;
            this.sweetalert.errorsweertalert("Invalid income range");
          } else {
            this.loader = false;
            this.submitted = false;
            this.sweetalert.errorsweertalert("Please fill mandatory fields");
          }
        } else if (Number(this.incomebandrange) > Number(this.totalincomerange)) {
          this.sweetalert.errorsweertalert(
            "Your total family income can not be less than your income"
          );
          this.submitted = false;
          this.loader = false;
        } else if (
          (Number(this.incomebandrange) < Number(this.totalincomerange) &&
            this.Father == "N" &&
            this.Mothers == "N" &&
            this.Spouse == "N" &&
            this.UnmarriedChildren == "N") ||
          ((Number(this.incomebandrange) == Number(this.totalincomerange) ||
            Number(this.incomebandrange) < Number(this.totalincomerange)) &&
            (this.Father == "Y" ||
              this.Mothers == "Y" ||
              this.Spouse == "Y" ||
              this.UnmarriedChildren == "Y"))
        ) {
          // if (Number(this.totalincomerange) <= 25000) {
          //   this.sweetalert.errorsweertalert(
          //     "Minimum monthly house-hold income eligibility is Rs.25,001."
          //   );
          // } else 
          if (
            this.Father == "N" &&
            this.Mothers == "N" &&
            this.Spouse == "N" &&
            this.UnmarriedChildren == "N"
          ) {
            //console.log("data: 2.1");
            this.sweetalert.errorsweertalert(
              "Please select Earning family members"
            );
          } else {
            this.saveMfiData();
          }
          this.submitted = false;
          this.loader = false;
        } else {
          //console.log("data: 6");
          this.saveMfiData();
        }
      } else if (
        this.incomebandrange !== "" &&
        Number(this.incomebandrange) > Number(this.mfiSalaryVal)
      ) {
        if (this.incomebandrange > 9999999 || this.incomebandrange < 1000) {
          this.sweetalert.errorsweertalert("Invalid income range");
          this.loader = false;
          this.submitted = false;
        } else {
          this.totalincomerange = "";
          this.Father = "N";
          this.Mothers = "N";
          this.UnmarriedChildren = "N";
          this.Spouse = "N";
          this.saveMfiData();
        }
      } else if (this.incomebandrange == "") {
        //console.log("data: 5");
        this.sweetalert.errorsweertalert("Please fill mandatory fields");
        this.loader = false;
        this.submitted = false;
      }
      this.loader = false;
    }
  }
  saveMfiData() {
    let selectedReasonList = this.reasonList.filter(e => e.code == this.selectedReason);
    let mfiData: any;
    if (this.encData != null && this.encData != '') {
      mfiData = {
        customer_id: this.custid,
        mobile_no: this.mobile,
        status: "Y",
        borrower_income: this.incomebandrange,
        martial_status: this.checkboxVal,
        fm_father: this.Father,
        fm_mother: this.Mothers,
        fm_umarried_children: this.UnmarriedChildren,
        fm_pouse: this.Spouse,
        total_family_income: this.totalincomerange,
        system: this.system,
        reason: this.selectedReason,
        previousincome: this.previousincome,
        value: selectedReasonList.size > 0 ? selectedReasonList[0].type : "",
        data: this.encData
      };
    }
    else {
      mfiData = {
        customer_id: this.custid,
        mobile_no: this.mobile,
        status: "Y",
        borrower_income: this.incomebandrange,
        martial_status: this.checkboxVal,
        fm_father: this.Father,
        fm_mother: this.Mothers,
        fm_umarried_children: this.UnmarriedChildren,
        fm_pouse: this.Spouse,
        total_family_income: this.totalincomerange,
        system: this.system,
        reason: this.selectedReason,
        previousincome: this.previousincome,
        value: selectedReasonList.size > 0 ? selectedReasonList[0].type : ""
      };
    }

    this.loader = true;
    console.log("mfiData:" + JSON.stringify(mfiData));
    this.service.saveData(mfiData).subscribe((data: any) => {
      this.loader = true;
      if (typeof data === "object") {
        this.responseData = JSON.parse(data.data);
        //console.log("event:" + JSON.stringify(this.responseData));
        if (this.responseData.STATUS_CODE == "ER") {
          this.sweetalert.errorsweertalert(this.responseData.STATUS_MESSAGE);
          this.loader = false;
          this.submitted = false;
        }
        else if (this.responseData.STATUS_CODE == "SR" && this.responseData.SYSTEM == "SAATHI") {
          this.loader=false;
          this.sweetalert.success_sweertalert(this.responseData.STATUS_MESSAGE);
           try {
              // @ts-ignore
              Dialog1.showMsg1("InstaCardHome");
            } catch (e) {
              alert("problem in method")
              alert(e)
            }
        }
        else if (this.responseData.STATUS_CODE == "SR") {
          this.sweetalert.success_sweertalert(this.responseData.STATUS_MESSAGE);
          setTimeout(() => {
            window.location.href = this.responseData.REDIRURL;
          }, 1000);
          this.loader = false;
        } else {
          this.sweetalert.errorsweertalert("Something went wrong");
          this.loader = false;
          this.submitted = false;
        }
      }
    });
    this.loader = false;
    this.submitted = false;
  }

  get b() {
    return this.basicdetailsform.controls;
  }
  onItemChange(value) {
    //console.log(this.checked);
    this.checkboxVal = value;
    //console.log(this.checkboxVal);
    this.Father = "N";
    this.Mothers = "N";
    this.UnmarriedChildren = "N";
    this.Spouse = "N";
  }

  onItemChangeFather(event) {
    //console.log("onItemChangeFather" + event.currentTarget.checked);
    if (event.currentTarget.checked == true) {
      this.Father = "Y";
      //console.log(this.Father);
    } else {
      this.Father = "N";
      //console.log(this.Father);
    }
  }
  onItemChangeMother(event) {
    //console.log(event.currentTarget.checked);
    if (event.currentTarget.checked == true) {
      this.Mothers = "Y";
      //console.log(this.Mothers);
    } else {
      this.Mothers = "N";
      //console.log(this.Mothers);
    }
  }

  onItemChangeSpouse(event) {
    //this.accepted = true;
    //console.log(event.currentTarget.checked);
    if (event.currentTarget.checked == true) {
      this.Spouse = "Y";
      //console.log(this.Spouse);
    } else {
      this.Spouse = "N";
      //console.log(this.Spouse);
    }
  }
  onItemChangeUnmarriedChildren(event) {
    //console.log(event.currentTarget.checked);
    if (event.currentTarget.checked == true) {
      this.UnmarriedChildren = "Y";
      //console.log(this.UnmarriedChildren);
    } else {
      this.UnmarriedChildren = "N";
      //console.log(this.UnmarriedChildren);
    }
  }
  onReasonSelectChange(e: any) {
    console.log("reason value", e.target.value);
    console.log("value", typeof (e.target.value));
    this.selectedReason = e.target.value != 'undefined' ? e.target.value : '';

  }
}

